import { render, staticRenderFns } from "./PaymentMethodModal.vue?vue&type=template&id=68995776&scoped=true&"
import script from "./PaymentMethodModal.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68995776",
  null
  
)

export default component.exports